import React from "react";
import PropTypes from "prop-types";
import OfferList from "../components/OfferList.jsx";
import AvailableDurations from "app/pages/.shared/AvailableDurations";
import Loader from "app/pages/.shared/Loader.jsx";

export const SearchEngineOffers = ({
	prePackageOffer,
	fields,
	onOfferChange,
	allAvailableDurations,
}) => {
	const hasPrepackageOffers = prePackageOffer.offers && prePackageOffer.offers.length > 0;

	return (
		<div className="search-engine__offer">
			{(hasPrepackageOffers && (
				<React.Fragment>
					<OfferList
						offers={prePackageOffer.offers}
						field={fields.offer}
						onOfferChange={onOfferChange}
					/>
				</React.Fragment>
			)) || (
				<div className="search-engine__loader">
					<Loader />
				</div>
			)}

			{allAvailableDurations.length > 0 && (
				<div className="search-engine__available-durations">
					<AvailableDurations durations={allAvailableDurations} />
				</div>
			)}
		</div>
	);
};

SearchEngineOffers.defaultProps = {
	allAvailableDurations: [],
	prePackageOffer: {},
	fields: {},
	shop: "",
};

SearchEngineOffers.propTypes = {
	prePackageOffer: PropTypes.object,
	fields: PropTypes.object,
	onOfferChange: PropTypes.func,
	allAvailableDurations: PropTypes.arrayOf(PropTypes.number),
};
